import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useModalLayer } from 'ud-ui/components/modal/modal-layer-context';

/**
 * Мост «правки Formik → окно» (IMGM-1623). Кладётся внутрь `<Formik>`, который стоит в
 * `UDModal`: пока в форме есть правки (`dirty`), клик вне окна, Escape и крестик не закрывают окно
 * молча, а спрашивают «Бросить изменения?». Вне окна ничего не делает.
 *
 * Ничего не рисует. Уход формы из дерева снимает флаг — следующая форма в том же окне начинает
 * чистой.
 */
export function UDModalDirtyGuard() {
  const { dirty } = useFormikContext();
  const { setDirty } = useModalLayer();

  useEffect(() => {
    setDirty(dirty);
  }, [dirty, setDirty]);

  useEffect(() => () => setDirty(false), [setDirty]);

  return null;
}
